import axios from './config';
import { cleanContent } from '../lib/editor-embed';

const list = (params, successCb, errorCb) => {
  axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/newsletters`, { params },
  ).then(
    res => successCb(res.data),
  ).catch(
    err => errorCb(err),
  );
};

const get = (id, successCb) => {
  axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/newsletter/${id}`,
  ).then(
    res => successCb(res.data),
  ).catch(
    err => console.error('api.newsletters.get() received error from api request:', err),
  );
};

const post = (params, successCb, errorCb) => {
  let { newsletter } = params;

  if (newsletter.content && newsletter.content.trim()) {
    newsletter.content = cleanContent(newsletter.content);
  }

  axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/newsletter`,
    newsletter,
  ).then(
    res => successCb(res.data),
  ).catch(
    errorCb,
  );
};

const put = (params, successCb, errorCb) => {
  let { newsletter } = params;

  if (newsletter.content && newsletter.content.trim()) {
    newsletter.content = cleanContent(newsletter.content);
  }

  axios.put(
    `${process.env.REACT_APP_API_BASE_URL}/newsletter/${params.id}`,
    newsletter,
  ).then(
    res => successCb(res.data),
  ).catch(
    errorCb,
  );
};

const resend = (id, successCb, errorCb) => {
  axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/newsletter/${id}/resend`,
  ).then(
    res => successCb(res.data),
  ).catch(
    errorCb,
  );
};

const endpoints = {
  list,
  get,
  post,
  put,
  resend,
};

export default endpoints;
